import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ACTION } from "./types";
import { doneAction, goBackAction, goToDashboard, needHelpAction } from "./actions";
import { ROUTE } from "../../../routes";
import { Platform } from "react-native";
import { getDateMonthYearFromEpoch, getDateMonthYearFromEpochIst } from "../../../configs/utils";
import { getAppHeader } from "../../../configs/config";
import { api } from "../../../configs/api";
import SharedPropsService from "../../../SharedPropsService";
import { LENDER_ID } from "../../../configs/constants";
export const template = (height, hideGoBack, stepperData, renewalRequestDetailsList, routeId) => ({
    layout: {
        id: ROUTE.LOAN_RENEWAL_STATUS_PAGE,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            Platform.OS === "ios" ? { id: 'spaceXXL', type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
            {
                id: "customHeader",
                type: WIDGET.CUSTOM_HEADER,
                position: POSITION.ABSOLUTE_TOP,
            },
            {
                id: "loanRepaymentStatusScreen",
                type: WIDGET.LOAN_RENEWAL_STATUS_PAGE,
            },
        ],
    },
    datastore: {
        customHeader: {
            // title: "Renew loan",
            hideGoBack: hideGoBack,
            needHelpAction: {
                routeId: ROUTE.LOAN_RENEWAL_STATUS_PAGE,
                type: ACTION.NEED_HELP,
                payload: { id: 'bt_getPortfolioScreen_needHelp_test' }
            },
            goBackAction: hideGoBack ? {} : {
                routeId: ROUTE.LOAN_RENEWAL_STATUS_PAGE,
                type: ACTION.GO_BACK,
                payload: {
                    id: 'bt_getPortfolioScreen_goBack_test_12',
                    routeId: routeId
                }
            }
        },
        loanRepaymentStatusScreen: {
            height: height - 58,
            stepperData: stepperData,
            renewalRequestDetailsList: renewalRequestDetailsList,
            doneAction: hideGoBack ? {
                type: ACTION.GO_TO_DASHBOARD,
                routeId: ROUTE.LOAN_RENEWAL_STATUS_PAGE,
                payload: {
                    routeId: routeId
                }
            } : {
                type: ACTION.DONE_ACTION,
                routeId: ROUTE.LOAN_RENEWAL_STATUS_PAGE,
                payload: {
                    routeId: routeId
                }
            }
        }
    },
});
export const loanRenewalStatusPage = {
    onLoad: async ({ getHeight, network, navigateToBase, ...props }, { hideGoBack, routeId }) => {
        console.log("routeId: ", routeId);
        const userData = await SharedPropsService.getUser();
        const creditId = userData?.linkedCredits[0]?.creditId;
        const getPendingCreditRequestResponse = await network.get(`${api.getPendingCreditRequest}${creditId}?creditRequestTypes=RENEWAL_REQUEST`, {
            headers: await getAppHeader(),
        });
        if (getPendingCreditRequestResponse?.data?.renewalRequestDetailsList &&
            getPendingCreditRequestResponse?.data?.renewalRequestDetailsList?.length === 0) {
            await navigateToBase(ROUTE.DASHBOARD);
        }
        const _renewalRequestDetails = getPendingCreditRequestResponse?.data?.renewalRequestDetailsList[0];
        let date = '';
        const lenderId = userData?.linkedApplications[0]?.lenderAccountId;
        const createdOnDateFromBE = _renewalRequestDetails?.createdOn;
        const expectedRenewalCompletionDateBE = _renewalRequestDetails?.expectedRenewalCompletionDate;
        const newDate = new Date(createdOnDateFromBE);
        const dateMonthYear = lenderId?.toLowerCase() === LENDER_ID.TATA ? getDateMonthYearFromEpochIst(createdOnDateFromBE) : getDateMonthYearFromEpoch(createdOnDateFromBE);
        const expectedRenewalCompletionDate = lenderId?.toLowerCase() === LENDER_ID.TATA ? getDateMonthYearFromEpochIst(expectedRenewalCompletionDateBE) : getDateMonthYearFromEpoch(expectedRenewalCompletionDateBE);
        const options = {
            timeZone: 'Asia/Calcutta',
            hour12: true,
            hour: 'numeric',
            minute: 'numeric',
        };
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        const istTime = newDate.toLocaleString('en-US', options);
        date = `${istTime}, ${dateMonthYear}`;
        const stepperData = [
            {
                "status": "COMPLETED",
                "verticalDisplayName": "Request placed successfully",
                "verticalDescription": `Placed on ${date}`,
                "order": 0
            },
            {
                "status": "IN_PROGRESS",
                "verticalDisplayName": "We’re processing your request",
                "verticalDescription": `Request to be completed by ${expectedRenewalCompletionDate}`,
                "order": 1
            },
        ];
        return Promise.resolve(template(getHeight(), hideGoBack, stepperData, _renewalRequestDetails, routeId));
    },
    actions: {
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.NEED_HELP]: needHelpAction,
        [ACTION.DONE_ACTION]: doneAction,
        [ACTION.GO_TO_DASHBOARD]: goToDashboard,
    },
    clearPrevious: true,
};
